import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { CountryCodes } from '../Helper/constants';

// Elements
import Container from 'react-bootstrap/Container'

export default class Footer extends Component {

    render() {
        const clinic = this.props.clinic;
        const contact = clinic.contact;
        const two_branches = !!contact.address2;
        const social_media = clinic.social_media || {};
        const socials = [
            { key: "facebook", icon: "fa-facebook-f", label: "Facebook" },
            { key: "instagram", icon: "fa-instagram", label: "Instagram" },
            { key: "youtube", icon: "fa-youtube", label: "YouTube" },
        ].filter(social => social.key in social_media);
        const quick_links = [
            clinic.team.length === 0 ? null : { label: "About us", to: "/about" },
            { label: "Our Services", href: "/#treatments" },
            clinic.gallery.general.length !== 0 ? { label: "Gallery", to: "/gallery" } : null,
            (clinic.abdm && clinic.abdm.enabled) ? { label: "Create ABHA", to: "/abdm/enroll" } : null,
        ].filter(Boolean);
        return (
        <>
        <footer className="footer">
            <Container>
                <div className="footer-grid">
                    <div className="footer-col footer-col--brand">
                        <img src={clinic.logo.path} alt={clinic.name || "clinic logo"} className="footer-logo"/>
                        {contact.address ?
                        <div className="footer-address">
                            {two_branches ? <span className="footer-address__label">Main Branch</span> : null}
                            <p>{contact.address}</p>
                        </div> : null}
                        {two_branches ?
                        <div className="footer-address">
                            <span className="footer-address__label">Second Branch</span>
                            <p>{contact.address2}</p>
                        </div> : null}
                        {clinic.team.length === 0 ? null :
                        <Link to="/about" className="text-link">Meet our team <i className="fa-solid fa-arrow-right"></i></Link>}
                    </div>

                    <div className="footer-col">
                        <h3 className="footer-label">Quick Links</h3>
                        <ul className="footer-links">
                            {quick_links.map(link => (
                                <li key={link.label}>
                                    {link.to ?
                                    <Link to={link.to}>{link.label}<i className="fa-solid fa-arrow-right"></i></Link> :
                                    <a href={link.href}>{link.label}<i className="fa-solid fa-arrow-right"></i></a>}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h3 className="footer-label">Opening Hours</h3>
                        <dl className="footer-hours">
                            {clinic.timing.map(_time => (
                                <div key={_time.days}><dt>{_time.days}</dt><dd>{_time.value}</dd></div>
                            ))}
                        </dl>
                    </div>

                    <div className="footer-col footer-col--contact">
                        <h3 className="footer-label">Contact</h3>
                        <ul className="footer-contact">
                            {contact.mobile.map(mobile => (
                                <li key={mobile}>
                                    <span className="footer-icon"><i className="fa-solid fa-phone"></i></span>
                                    <a href={`tel:${CountryCodes.india}${mobile}`}>{CountryCodes.india}-{mobile}</a>
                                </li>
                            ))}
                            {contact.email ?
                            <li>
                                <span className="footer-icon"><i className="fa-regular fa-envelope"></i></span>
                                <a href={`mailto:${contact.email}`}>{contact.email}</a>
                            </li> : null}
                        </ul>
                        {socials.length > 0 ?
                        <div className="footer-social">
                            {socials.map(social => (
                                <a key={social.key} href={social_media[social.key]} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                                    <i className={`fa-brands ${social.icon}`}></i>
                                </a>
                            ))}
                        </div> : null}
                    </div>
                </div>
            </Container>
        </footer>
        <div className="tiny-footer">
            <Container>
                <div className="band-row tiny-footer__inner">
                    <p>&copy; {new Date().getFullYear()} <strong>{this.props.clinic.name}</strong>. All rights reserved.</p>
                    <p>Powered by <a href={"https://dentostack.com"} target={"_blank"} rel="noopener noreferrer">Dentostack&#174;</a></p>
                </div>
            </Container>
        </div>
        </>
        );
    }
}
